import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { IReqTopChartsParams, IReqCategoryParams } from '@models/ranking/rankingModle';
import _ from 'lodash';
import { gameProviderTypes } from '@configs/layout';
import { COLLECTION } from '@models/app/featuredModel';
import moment from 'moment';

// TODO: 더미데이터 만드는 함수.. 추후 삭제할 것..
const rankingCategorySingleDummyData = () => {
  const baseDates = Array.from({ length: 12 }, (v, i) => i + 1).map((item) => {
    return `2022-03-${item >= 10 ? item : '0' + item}`;
  });
  const gameNames = ['onepunch'];
  const onePunchTypes = [
    'APPLICATION_TopFree',
    'APPLICATION_TopGross',
    'GAME_ACTION_TopFree',
    'GAME_ACTION_TopGross',
    'GAME_TopFree',
    'GAME_TopGross',
  ];

  const getPropertyByData = (gameName) => {
    return onePunchTypes;
  };

  let result = [];

  baseDates.forEach((baseDate) => {
    gameNames.forEach((gameName) => {
      getPropertyByData(gameName).forEach((property) => {
        result.push({
          baseDate,
          gameName,
          property,
          value: _.random(0, 100),
        });
      });
    });
  });

  return result;
};
const rankingCategoryDummyData = () => {
  const baseDates = Array.from({ length: 12 }, (v, i) => i + 1).map((item) => {
    return `2022-03-${item >= 10 ? item : '0' + item}`;
  });

  const gameNames = ['onepunch', 'bleach', 'kknd'];

  const onePunchTypes = [
    'APPLICATION_TopFree',
    'APPLICATION_TopGross',
    'GAME_ACTION_TopFree',
    'GAME_ACTION_TopGross',
    'GAME_TopFree',
    'GAME_TopGross',
  ];

  const bleachTypes = ['APPLICATION_TopPaid', 'GAME_ACTION_TopPaid', 'GAME_TopPaid'];

  const kknd = ['APPLICATION_TopFree', 'GAME_ACTION_TopFree', 'GAME_TopFree'];

  const getPropertyByData = (gameName) => {
    if (gameName === 'onepunch') {
      return onePunchTypes;
    } else if (gameName === 'bleach') {
      return bleachTypes;
    } else {
      return kknd;
    }
  };

  let result = [];

  baseDates.forEach((baseDate) => {
    gameNames.forEach((gameName) => {
      getPropertyByData(gameName).forEach((property) => {
        result.push({
          baseDate,
          gameName,
          property,
          value: _.random(0, 100),
        });
      });
    });
  });

  return result;
};

// TopCharts 데이터 요청
export const fetchTopChartsData = createAsyncThunk('fetchTopChartsData', async (params: IReqTopChartsParams) => {
  // TODO: 추후 변경 (지금은 G-star 버전)
  let freeRankingData, paidRankingData, grossRankingData;
  // free 콜랙션
  try {
    const { data: freeData, status: freeStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.TOP_FREE
          : COLLECTION.APP_STORE.TOP_FREE_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('freeData: ', freeData);
    console.log('freeStatus: ', freeStatus);
    freeRankingData = freeStatus === 200 ? freeData.slice(0, 10) : [];
  } catch (error) {
    console.log('free Error: ', error);
    freeRankingData = [];
  }

  // paid 콜랙션
  try {
    const { data: paidData, status: paidStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.TOP_PAID
          : COLLECTION.APP_STORE.TOP_PAID_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('paidData: ', paidData);
    console.log('paidStatus: ', paidStatus);
    paidRankingData = paidStatus === 200 ? paidData.slice(0, 10) : [];
  } catch (error) {
    console.log('paid Error: ', error);
    paidRankingData = [];
  }
  // grossing 콜랙션
  try {
    const { data: grossData, status: grossStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.GROSSING
          : COLLECTION.APP_STORE.TOP_GROSSING_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('grossData: ', grossData);
    console.log('grossStatus: ', grossStatus);
    grossRankingData = grossStatus === 200 ? grossData.slice(0, 10) : [];
  } catch (error) {
    console.log('error: ', error);
    grossRankingData = [];
  }

  // 여기서 데이터 조합처리
  // const freeRankingData =
  console.log(
    'freeRankingData, paidRankingData, grossRankingData: ',
    freeRankingData,
    paidRankingData,
    grossRankingData
  );
  if (!!freeRankingData && !!paidRankingData && !!grossRankingData) {
    return {
      freeRankingData,
      paidRankingData,
      grossRankingData,
      date: moment().format('YYYY-MM-DD'),
    };
  }
  // const { data, status } = await axiosDummyInstance.get('/api/ranking/topchartsData.json', { params });
  // if (status === 200) {
  //   console.log('Dummy data: ', data);
  //   return data;
  // }
});

// CategoryRankings 데이터 요청
export const fetchCategoryRankingsData = createAsyncThunk(
  'fetchCategoryRankingsData',
  async (params: IReqCategoryParams) => {
    const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', { params });
    if (status === 200) {
      return {
        myAppData: rankingCategorySingleDummyData(),
        competitionData: rankingCategoryDummyData(),
      };
    }
  }
);

// BiggestMover 데이터 요청
export const fetchMoverData = createAsyncThunk('fetchMoverData', async (params: IReqTopChartsParams) => {
  // TODO: 추후 변경
  const { data, status } = await axiosDummyInstance.get('/api/ranking/topchartsData.json', { params });
  if (status === 200) {
    return data;
  }
});

// BiggestLoser 데이터 요청
export const fetchLoserData = createAsyncThunk('fetchLoserData', async (params: IReqTopChartsParams) => {
  // TODO: 추후 변경
  const { data, status } = await axiosDummyInstance.get('/api/ranking/topchartsData.json', { params });
  if (status === 200) {
    return data;
  }
});

// NewApps 데이터 요청
export const fetchNewAppsData = createAsyncThunk('fetchNewAppsData', async (params: IReqTopChartsParams) => {
  // TODO: 추후 변경 (지금은 G-star 버전)
  let freeRankingData, paidRankingData, grossRankingData;
  // free 콜랙션
  try {
    const { data: freeData, status: freeStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.TOP_FREE
          : COLLECTION.APP_STORE.NEW_FREE_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('freeData: ', freeData);
    console.log('freeStatus: ', freeStatus);
    const tempFreeRankingData = freeStatus === 200 ? freeData.slice(0, 10) : [];
    freeRankingData =
      params.type === gameProviderTypes.GooglePlayStore
        ? tempFreeRankingData.sort((a, b) => moment(a).diff(moment(b)))
        : tempFreeRankingData;
  } catch (error) {
    console.log('free Error: ', error);
    freeRankingData = [];
  }

  // paid 콜랙션
  try {
    const { data: paidData, status: paidStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.TOP_PAID
          : COLLECTION.APP_STORE.NEW_PAID_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('paidData: ', paidData);
    console.log('paidStatus: ', paidStatus);
    const tempPaidRankingData = paidStatus === 200 ? paidData.slice(0, 10) : [];
    paidRankingData =
      params.type === gameProviderTypes.GooglePlayStore
        ? tempPaidRankingData.sort((a, b) => moment(a).diff(moment(b)))
        : tempPaidRankingData;
  } catch (error) {
    console.log('paid Error: ', error);
    paidRankingData = [];
  }
  // grossing 콜랙션
  try {
    const { data: grossData, status: grossStatus } = await axiosScraper.post(`${params.type}/list`, {
      category: params.category,
      num: params.num,
      collection:
        params.type === gameProviderTypes.GooglePlayStore
          ? COLLECTION.GOOGLE_PLAY_STORE.GROSSING
          : COLLECTION.APP_STORE.TOP_GROSSING_IOS,
      country: params.country, //selectedCountry state
    });
    console.log('grossData: ', grossData);
    console.log('grossStatus: ', grossStatus);
    const tempGrossRankingData = grossStatus === 200 ? grossData.slice(0, 10) : [];
    grossRankingData =
      params.type === gameProviderTypes.GooglePlayStore
        ? tempGrossRankingData.sort((a, b) => moment(a).diff(moment(b)))
        : tempGrossRankingData;
  } catch (error) {
    console.log('error: ', error);
    grossRankingData = [];
  }

  // 여기서 데이터 조합처리
  // const freeRankingData =
  console.log(
    'freeRankingData, paidRankingData, grossRankingData: ',
    freeRankingData,
    paidRankingData,
    grossRankingData
  );
  if (!!freeRankingData && !!paidRankingData && !!grossRankingData) {
    return {
      freeRankingData,
      paidRankingData,
      grossRankingData,
      date: moment().format('YYYY-MM-DD'),
    };
  }

  // const { data, status } = await axiosDummyInstance.get('/api/ranking/topchartsData.json', { params });
  // if (status === 200) {
  //   return data;
  // }
});
